import React from "react";
import ReactDOM from "react-dom/client"; // Asegúrate de que la importación es desde 'react-dom/client'
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./index.css";

// Utiliza createRoot de 'react-dom/client'
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Router>
    <App />
  </Router>
);
